import { http } from '@/lib/http';
import type { PurchaseOrder, PurchaseOrderStatus } from '@/types/purchase-orders';

const BASE = '/api/v1/purchase-orders';

export interface PurchaseOrderListQuery {
  status?: PurchaseOrderStatus;
  vendorId?: string;
  search?: string;
  page?: number;
  pageSize?: number;
}

export interface PurchaseOrderListResponse {
  rows: PurchaseOrder[];
  page: number;
  pageSize: number;
  total: number;
}

export interface PurchaseOrderLinePayload {
  itemId: string;
  /** Always in BASE units. */
  quantity: number;
  unitPrice?: number;
}

export interface CreatePurchaseOrderPayload {
  vendorId: string;
  warehouseId: string;
  items: PurchaseOrderLinePayload[];
  externalPoRef?: string;
  expectedDeliveryAt?: string;
  notes?: string;
  /** Issue immediately on create (skip DRAFT). */
  issueImmediately?: boolean;
}

export interface UpdatePurchaseOrderStatusPayload {
  status: PurchaseOrderStatus;
  reason?: string;
}

export const purchaseOrdersService = {
  list: (query: PurchaseOrderListQuery = {}) =>
    http.get<PurchaseOrderListResponse>(BASE, { params: query }),
  get: (id: string) => http.get<PurchaseOrder>(`${BASE}/${id}`),
  create: (payload: CreatePurchaseOrderPayload) =>
    http.post<PurchaseOrder, CreatePurchaseOrderPayload>(BASE, payload),
  updateStatus: (id: string, payload: UpdatePurchaseOrderStatusPayload) =>
    http.patch<PurchaseOrder, UpdatePurchaseOrderStatusPayload>(
      `${BASE}/${id}/status`,
      payload,
    ),
};
